import { render, staticRenderFns } from "./CopyToClipboardText.vue?vue&type=template&id=1e6fc800&scoped=true&"
import script from "./CopyToClipboardText.vue?vue&type=script&lang=js&"
export * from "./CopyToClipboardText.vue?vue&type=script&lang=js&"
import style0 from "./CopyToClipboardText.vue?vue&type=style&index=0&id=1e6fc800&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e6fc800",
  null
  
)

export default component.exports